import { gql } from '@apollo/client'

import { DriverDetailsFragment } from 'graphql/fragments'

export const CREATE_DRIVER = gql`
  mutation CreateDriver($input: CreateAndUpdateDriverDtoInput!) {
    createDriver(input: $input) {
      ...DriverDetails
    }
    
    ${DriverDetailsFragment}
  }
`

export const UPDATE_DRIVER = gql`
  mutation UpdateDriver($input: CreateAndUpdateDriverDtoInput!) {
    updateDriver(input: $input) {
      ...DriverDetails
    }

    ${DriverDetailsFragment}
  }
`

export const UPDATE_DRIVER_ONBOARDING = gql`
  mutation UpdateDriverOnboarding(
    $input: DriverOnboardingDtoInput!
    $isMobileOnboarding: Boolean!
  ) {
    updateDriverOnboarding(input: $input, isMobileOnboarding: $isMobileOnboarding) {
      id
      isOnboardingCompleted
      isMobileOnboardingCompleted
    }
  }
`

export const UPDATE_DRIVER_APP_SETTINGS = gql`
  mutation UpdateDriverAppSettings($input: DriverAppSettingsDtoInput!) {
    updateDriverAppSettings(input: $input) {
      id
      isEmailNotification
      isEmailNotificationForNewAvailableBookings
      isMobileAppNotification
      isMobileNotificationForNewAvailableBookings
      isMobileNotificationForHgvJobs
      isMobileNotificationForNonHgvJobs
      notificationRadiusKm
    }
  }
`

export const DELETE_DRIVER_MUTATION = gql`
  mutation DeleteDriver($driverId: Long!) {
    deleteDriver(driverId: $driverId)
  }
`

export const CREATE_SUB_DRIVER = gql`
  mutation CreateSubDriver($input: CreateAndUpdateSubDriverDtoInput!) {
    createSubDriver(input: $input) {
      id
      primaryDriverId
      email
      isActive
      firstName
      lastName
      telephoneNumber
      identityUserName
      role
    }
  }
`

export const UPDATE_SUB_DRIVER = gql`
  mutation UpdateSubDriver($input: CreateAndUpdateSubDriverDtoInput!) {
    updateSubDriver(input: $input) {
      id
      primaryDriverId
      email
      isActive
      firstName
      lastName
      telephoneNumber
      role
    }
  }
`

export const CREATE_DRIVER_CONTACT = gql`
  mutation CreateDriverContact($input: CreateAndUpdateDriverContactDtoInput!) {
    createDriverContact(input: $input) {
      id
      driverId
      name
      isDefault
      telephoneNumber
      email
      additionalEmails
      department
      jobRole
    }
  }
`

export const UPDATE_DRIVER_CONTACT = gql`
  mutation UpdateDriverContact($input: CreateAndUpdateDriverContactDtoInput!) {
    updateDriverContact(input: $input) {
      id
      driverId
      name
      isDefault
      telephoneNumber
      email
      additionalEmails
      department
      jobRole
    }
  }
`

export const DELETE_DRIVER_CONTACT = gql`
  mutation DeleteDriverContact($driverContactId: Long!) {
    deleteDriverContact(driverContactId: $driverContactId)
  }
`

export const UPDATE_BOOKING_DRIVER_RATING = gql`
  mutation updateBookingDriverRating($input: BookingDriverRatingDtoInput!) {
    updateDriverRating(input: $input) {
      id
      bookingId
      rating
      ratingComment
      driver {
        id
        averageRating
      }
    }
  }
`

export const CHANGE_DRIVER_ROLE = gql`
  mutation changeDriverRole($input: ChangeDriverRoleDtoInput!) {
    changeDriverRole(input: $input) {
      id
      identityUserName
      role
    }
  }
`

export const CREATE_OR_UPDATE_DRIVER_LOCATION = gql`
  mutation CreateOrUpdateDriverLocation($input: CreateOrUpdateDriverLocationDtoInput!) {
    createOrUpdateDriverLocation(input: $input) {
      id
    }
  }
`

export const GENERATE_MANUAL_DRIVER_INVOICES = gql`
  mutation GenerateManualDriverInvoices($bookingDriverIds: [Long!]!) {
    generateManualDriverInvoices(bookingDriverIds: $bookingDriverIds) {
      bookingDriverId
      bookingId
      bookingReference
      driverName
      isQueued
      isAprOnly
      errorMessage
    }
  }
`
